import axios from "../axios";
import api from "@/store/api";

export const state = {
  result: [],
  csvResult: '',
  reqStatus: 'idle',
  form: {
    name: ''
  },
  filters: {
    followers_count: 10,
    is_data_valid: true,
    is_apollo_match: false
  },
  searchName: '',
  errorMsg: '',
}

export const mutations = {
  SET_SM_STATE(state, {key, value}) {
    state[key] = value
  },
  SET_SM_FILTER(state, {name, value}) {
    switch (name) {
      case 'is_data_valid':
      case 'is_apollo_match':
        state.filters[name] = !state.filters[name]
        break
      case 'followers_count':
        state.filters[name] = value ? parseInt(value) : ''
        break
      default:
        state.filters[name] = value
    }
  },
  SET_SM_FORM_FIELD(state, {name, value}) {
    state.form[name] = value
  },
}

export const actions = {
  async get_sm_filters({commit}) {
    try {
      commit('SET_REQ_STATUS', 'fetching')
      const {data} = await axios.get(api.sm_enricher.filters)
      commit('SET_SM_STATE', {key: 'filters', value: data})
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async save_sm_filters ({state, commit}) {
    try {
      commit('SET_REQ_STATUS', 'fetching')
      await axios.put(api.sm_enricher.filters, state.filters)
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async send_sm_data ({state, commit}) {
    try {
      commit('SET_REQ_STATUS', 'sending')
      commit('SET_SM_STATE', {key: 'result', value: []})
      commit('SET_SM_STATE', {key: 'csvResult', value: ''})
      const {data} = await axios.post(api.sm_enricher.scores, {...state.form, ...state.filters})
      commit('SET_SM_STATE', {key: 'searchName', value: state.form.name.toString()})
      commit('SET_SM_STATE', {key: 'result', value: data})
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
      commit('SET_SM_STATE', {key: 'errorMsg', value: err.response?.data})
    }
  },
  async send_sm_data_csv ({commit, rootState}, {
    formData, clbk = () => {
    }
  }) {
    try {
      commit('SET_REQ_STATUS', 'sending')
      commit('SET_SM_STATE', {key: 'result', value: []})
      commit('SET_SM_STATE', {key: 'csvResult', value: ''})
      Object.keys(state.filters)
        .forEach(key => {
          formData.append(key, state.filters[key])
        })
      formData.append('emailToSendCSV', rootState.emailToSendCSV)
      const {data} = await axios.post(`${api.sm_enricher.scores}/csv`, formData)
      commit('SET_SM_STATE', {key: 'result', value: []})
      commit('SET_SM_STATE', {key: 'csvResult', value: data})
      commit('SET_SM_STATE', {key: 'searchName', value: ''})
      commit('SET_REQ_STATUS', 'success')
      clbk();
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
      console.log(err)
      commit('SET_SM_STATE', {key: 'errorMsg', value: err.response?.data})
    }
  },
}